import { ReactNode } from "react";

export type PillTone = "ok" | "warn" | "bad" | "none" | "blue";

// Small uppercase status label with a coloured dot
const Pill = ({ tone, children }: { tone: PillTone; children: ReactNode }) => (
  <span className={`cx-pill ${tone}`}><i></i>{children}</span>
);

export default Pill;
